"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerValidators = exports.ValidationMethodBase = exports.NoUnderwritingRuleFailuresValidation = exports.UnderwritingRuleValidation = exports.ExpressionValidation = exports.DateRangeValidation = exports.DateMinValidation = exports.DateMaxValidation = exports.DateValidation = exports.EqualsValidation = exports.RegexValidation = exports.EmailValidation = exports.NumericRangeValidation = exports.NumericMaxValidation = exports.NumericMinValidation = exports.NumericValidation = exports.MandatoryValidation = void 0;
var MandatoryValidation_1 = require("./MandatoryValidation");
Object.defineProperty(exports, "MandatoryValidation", { enumerable: true, get: function () { return MandatoryValidation_1.MandatoryValidation; } });
var NumericValidation_1 = require("./NumericValidation");
Object.defineProperty(exports, "NumericValidation", { enumerable: true, get: function () { return NumericValidation_1.NumericValidation; } });
var NumericMinValidation_1 = require("./NumericMinValidation");
Object.defineProperty(exports, "NumericMinValidation", { enumerable: true, get: function () { return NumericMinValidation_1.NumericMinValidation; } });
var NumericMaxValidation_1 = require("./NumericMaxValidation");
Object.defineProperty(exports, "NumericMaxValidation", { enumerable: true, get: function () { return NumericMaxValidation_1.NumericMaxValidation; } });
var EmailValidation_1 = require("./EmailValidation");
Object.defineProperty(exports, "EmailValidation", { enumerable: true, get: function () { return EmailValidation_1.EmailValidation; } });
var RegexValidation_1 = require("./RegexValidation");
Object.defineProperty(exports, "RegexValidation", { enumerable: true, get: function () { return RegexValidation_1.RegexValidation; } });
var EqualsValidation_1 = require("./EqualsValidation");
Object.defineProperty(exports, "EqualsValidation", { enumerable: true, get: function () { return EqualsValidation_1.EqualsValidation; } });
var DateValidation_1 = require("./DateValidation");
Object.defineProperty(exports, "DateValidation", { enumerable: true, get: function () { return DateValidation_1.DateValidation; } });
var DateMaxValidation_1 = require("./DateMaxValidation");
Object.defineProperty(exports, "DateMaxValidation", { enumerable: true, get: function () { return DateMaxValidation_1.DateMaxValidation; } });
var DateMinValidation_1 = require("./DateMinValidation");
Object.defineProperty(exports, "DateMinValidation", { enumerable: true, get: function () { return DateMinValidation_1.DateMinValidation; } });
var DateRangeValidation_1 = require("./DateRangeValidation");
Object.defineProperty(exports, "DateRangeValidation", { enumerable: true, get: function () { return DateRangeValidation_1.DateRangeValidation; } });
var ExpressionValidation_1 = require("./ExpressionValidation");
Object.defineProperty(exports, "ExpressionValidation", { enumerable: true, get: function () { return ExpressionValidation_1.ExpressionValidation; } });
var UnderwritingRuleValidation_1 = require("./UnderwritingRuleValidation");
Object.defineProperty(exports, "UnderwritingRuleValidation", { enumerable: true, get: function () { return UnderwritingRuleValidation_1.UnderwritingRuleValidation; } });
var NoUnderwritingRuleFailuresValidation_1 = require("./NoUnderwritingRuleFailuresValidation");
Object.defineProperty(exports, "NoUnderwritingRuleFailuresValidation", { enumerable: true, get: function () { return NoUnderwritingRuleFailuresValidation_1.NoUnderwritingRuleFailuresValidation; } });
var NumericRangeValidation_1 = require("./NumericRangeValidation");
Object.defineProperty(exports, "NumericRangeValidation", { enumerable: true, get: function () { return NumericRangeValidation_1.NumericRangeValidation; } });
var ValidationMethodBase_1 = require("./ValidationMethodBase");
Object.defineProperty(exports, "ValidationMethodBase", { enumerable: true, get: function () { return ValidationMethodBase_1.ValidationMethodBase; } });
function registerValidators(journeyComponentsManager) {
    journeyComponentsManager.addValidation({
        id: "mandatory",
        method: MandatoryValidation_1.MandatoryValidation,
    });
    journeyComponentsManager.addValidation({
        id: "numeric",
        method: NumericValidation_1.NumericValidation,
    });
    journeyComponentsManager.addValidation({
        id: "numericMin",
        method: NumericMinValidation_1.NumericMinValidation,
    });
    journeyComponentsManager.addValidation({
        id: "numericMax",
        method: NumericMaxValidation_1.NumericMaxValidation,
    });
    journeyComponentsManager.addValidation({
        id: "numericRange",
        method: NumericRangeValidation_1.NumericRangeValidation,
    });
    journeyComponentsManager.addValidation({
        id: "regex",
        method: RegexValidation_1.RegexValidation,
    });
    journeyComponentsManager.addValidation({
        id: "email",
        method: EmailValidation_1.EmailValidation,
    });
    journeyComponentsManager.addValidation({
        id: "equals",
        method: EqualsValidation_1.EqualsValidation,
    });
    journeyComponentsManager.addValidation({
        id: "date",
        method: DateValidation_1.DateValidation,
    });
    journeyComponentsManager.addValidation({
        id: "dateMin",
        method: DateMinValidation_1.DateMinValidation,
    });
    journeyComponentsManager.addValidation({
        id: "dateMax",
        method: DateMaxValidation_1.DateMaxValidation,
    });
    journeyComponentsManager.addValidation({
        id: "dateRange",
        method: DateRangeValidation_1.DateRangeValidation,
    });
    journeyComponentsManager.addValidation({
        id: "expression",
        method: ExpressionValidation_1.ExpressionValidation,
    });
    journeyComponentsManager.addValidation({
        id: "underwritingRule",
        method: UnderwritingRuleValidation_1.UnderwritingRuleValidation
    });
    journeyComponentsManager.addValidation({
        id: "noUnderwritingRuleFailures",
        method: NoUnderwritingRuleFailuresValidation_1.NoUnderwritingRuleFailuresValidation
    });
}
exports.registerValidators = registerValidators;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/journey-services/dist/validations/index.js
// module id = 2068
// module chunks = 0